export const MENU_TOGGLE = 'MENU_TOGGLE';
export const menuToggle = () => ({
  type: MENU_TOGGLE
});


// WEBPACK FOOTER //
// ./src/actions/header.js